module.exports = __webpack_public_path__ + "img/H.fe4ca0c9.gif";